/**
 * Whether the store owns an order waiting for payment: pickup location first, else origin, like the API.
 *
 * @param {Object} order
 * @param {string} storeId the current store
 * @returns {boolean}
 */
export function isPaymentValidationStore(order, storeId) {
  if (!order || !storeId) {
    return false
  }
  if (order.pickup_location_id) {
    // Orders picked up in store stay restricted to store delivery.
    return order.pickup_location_id === storeId && order.carrier?.carrier_type === 'store_delivery'
  }
  return order.origin_location_id === storeId
}
